const quickPayPaths = [
  "/quick-info",
  "/quick-payment",
  "/quick-review",
  "/quick-confirmation",
];

export const isQuickPayRoute = (pathname: string) =>
  quickPayPaths.some((path) => pathname.includes(path));
